// extracted by mini-css-extract-plugin
export default {"toastCloseBtn":"CustomToasts_toastCloseBtn__SiAxI","toastIcon":"CustomToasts_toastIcon__3OS7Y","toastIconBg":"CustomToasts_toastIconBg__Kfnbx"};